import React from "react";
import "./FeelingProud.css";

function FeelingProud(props) {
  const theme = props.theme;
  return (
    <div className="tech-lead-animation">
      <div className="code-window">
        <div className="code-header">
          <div className="code-dot red"></div>
          <div className="code-dot yellow"></div>
          <div className="code-dot green"></div>
          <span className="code-title">TechLead.js</span>
        </div>
        <div className="code-content">
          <div className="code-line">
            <span className="code-keyword">const</span>{" "}
            <span className="code-variable">techLead</span> = {"{"}
          </div>
          <div className="code-line indent">
            <span className="code-property">role</span>:{" "}
            <span className="code-string">"Tech Lead"</span>,
          </div>
          <div className="code-line indent">
            <span className="code-property">skills</span>: [
          </div>
          <div className="code-line indent-2">
            <span className="code-string">"Leadership"</span>,
          </div>
          <div className="code-line indent-2">
            <span className="code-string">"Architecture"</span>,
          </div>
          <div className="code-line indent-2">
            <span className="code-string">"Mentoring"</span>,
          </div>
          <div className="code-line indent-2">
            <span className="code-string">"Innovation"</span>
          </div>
          <div className="code-line indent">],</div>
          <div className="code-line indent">
            <span className="code-property">status</span>:{" "}
            <span className="code-string">"Ready to Lead"</span>
          </div>
          <div className="code-line">{"};"}</div>
          <div className="cursor-blink">|</div>
        </div>
      </div>
      <div className="floating-icons">
        <div className="icon-react">⚛️</div>
        <div className="icon-code">💻</div>
        <div className="icon-rocket">🚀</div>
        <div className="icon-lightbulb">💡</div>
      </div>
    </div>
  );
}

export default FeelingProud;
